"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { usePostHog } from "@/providers/PostHogProvider";

type Props = ComponentProps<typeof Link> & {
  eventName: string;
  eventProperties?: Record<string, string>;
};

export default function TrackedLink({ eventName, eventProperties, onClick, ...props }: Props) {
  const posthog = usePostHog();

  return (
    <Link
      {...props}
      onClick={(event) => {
        posthog?.capture(eventName, eventProperties);
        onClick?.(event);
      }}
    />
  );
}
